<script setup lang="ts">
  import { SelectInput, DatePicker, IconImage } from '@/shared/ui';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';
  import AddButton from '@/shared/assets/icons/AddButton.svg';
  import DeleteButton from '@/shared/assets/icons/DeleteButton.svg';
  import type { SessionState, SessionActions, SessionHelpers } from './types/session.types';

  defineProps<{
    index: number;
    state: SessionState;
    actions: SessionActions;
    helpers: SessionHelpers;
    isFirst: boolean;
    isAddDisabled: boolean;
  }>();
</script>

<template>
  <div class="flex items-end justify-between">
    <div class="grid grid-cols-3 gap-4">
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-07">Colaborador ministrante</span>
        <SelectInput
          :model-value="state.memberId"
          :options="helpers.userOptions"
          label="Selecione o colaborador"
          @update:model-value="actions.setMemberId(index, $event)"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-07">Cargo</span>
        <SelectInput
          :model-value="state.positionId"
          :options="helpers.getUserPositions(state.memberId)"
          label="Selecione o cargo"
          @update:model-value="actions.setPositionId(index, $event)"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-07">Data do treinamento</span>
        <button
          type="button"
          class="flex items-center gap-2 bg-white-01 px-4 py-2.5 border border-gray-02 rounded-lg text-gray-07 text-sm focus:outline-none focus:border-gray-07"
          @click="actions.setDatePickerOpen(index, true)"
        >
          <IconImage
            :src="CalendarIcon"
            alt="Calendário"
            class="h-4 w-4"
          />
          {{ helpers.formatDate(state.dateString) }}
        </button>
        <DatePicker
          :selected-date="state.date"
          :is-open="state.datePickerOpen"
          @update:selected-date="actions.setDate(index, $event)"
          @update:is-open="actions.setDatePickerOpen(index, $event)"
        />
      </div>
    </div>
    <div class="h-[46px] flex items-center text-[var(--theme-secondary-ink)]">
      <IconImage
        v-if="!isFirst"
        :src="DeleteButton"
        alt="Remover"
        class="cursor-pointer"
        @click="actions.removeSession(index)"
      />
      <IconImage
        v-if="isFirst"
        :src="AddButton"
        alt="Adicionar"
        :class="isAddDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'"
        @click="!isAddDisabled && actions.addSession()"
      />
    </div>
  </div>
</template>
